import { Source } from '../../enums';
import { JobPolicyThresholds } from '../policies';
import { CodeCategory, CodeStatus, CodeType, CodeUoM, EmbeddedCodeLike } from '../shared';
import { EntitySubStatus } from '../entity.status';


export enum ClaimItemStatus {
    Linked = 'Linked',
    Unlinked = 'Unlinked',
}

export interface ClaimItem {
    _id: string;
    name: string;
    description: string;
    longDescription?: string;
    quantity: number;
    location: string;
    note: string;
    type: CodeType;
    status: CodeStatus;
    itemStatus: EntitySubStatus,
    price: number;
    codeUoM: CodeUoM;
    category: CodeCategory;


    /* This is the _id in the contractors system */
    integrationId?: string;
    integrationDate?: Date;

    //job: Entity;
    //stage: Entity;
    system: boolean; // from tenant ?
    isLinked?: boolean;
    claimImport?: boolean;
    source?: Source;
    isReadonly?: boolean;
    isClaimCode?: boolean;
}

export interface ClaimItems {
    remote: ClaimItem[];
    local: ClaimItem[];
    threshold?: JobPolicyThresholds;
}

export type PortalEditableClaimItem = Partial<Pick<ClaimItem, '_id' | 'quantity' | 'location' | 'note'>>;

export const emptyClaimItems = {
    remote: [],
    local: []
}

export const toClaimItem = (item: EmbeddedCodeLike, option?: { priceSource?: 'BUY' | 'SELL', system?: boolean, linked?: boolean, appendLongDescription?: boolean, isClaimCode?: boolean }): ClaimItem => {

    if (!item) {
        return null;
    }

    const system = option?.system ?? item.system;
    const isLinked = system ? false : option?.linked;
    const price = (option?.priceSource ?? 'BUY') === 'BUY'
        ? item.buyPrice
        : item.sellPrice;

    const result: ClaimItem = {
        _id: item._id,
        name: item.name,
        description: item.description,
        quantity: item.quantity,
        location: item.location,
        note: item.note,
        status: item.status,
        itemStatus: item.itemStatus,
        type: item.type,
        price: price,
        codeUoM: item.codeUoM,
        category: item.category,
        integrationId: item.integrationId,
        system,
        isLinked,
        source: item.source,
        isClaimCode: option?.isClaimCode
    };

    if (result.isClaimCode) {
        delete result.status;
    }
    else {
        delete result.itemStatus;
    }

    if (option?.appendLongDescription) {
        result.longDescription = item.longDescription;
    }

    return result;

};